import { useState } from "react";
import { Sparkles, Palette, Globe } from "lucide-react";
import HeroSection from "../../../components/ui/HeroSection";
import Branding from "../Branding";
import Domains from "../Domains";

type Tab = "branding" | "domains";

// Combined white-label settings: branding (logo/name/favicon on the public
// gate pages) + custom domains, under one menu.
const WhiteLabel = () => {
  const [tab, setTab] = useState<Tab>("branding");

  const TABS: { key: Tab; label: string; icon: any }[] = [
    { key: "branding", label: "Branding", icon: Palette },
    { key: "domains", label: "Custom domains", icon: Globe },
  ];

  return (
    <div className="space-y-6">
      <HeroSection
        eyebrow={
          <>
            <Sparkles size={11} className="text-brand-500" />
            <span>White-label</span>
          </>
        }
        title="White-label settings"
        description="Brand your link pages and use your own domain — everything your visitors see, as you."
      />

      <div className="inline-flex p-0.5 bg-ink-100 rounded-lg">
        {TABS.map((t) => {
          const Icon = t.icon;
          const active = tab === t.key;
          return (
            <button
              key={t.key}
              type="button"
              onClick={() => setTab(t.key)}
              className={`inline-flex items-center gap-1.5 h-8 px-3 rounded-md text-sm font-medium transition-all ${
                active
                  ? "bg-white text-ink-900 shadow-sm"
                  : "text-ink-500 hover:text-ink-900"
              }`}
            >
              <Icon size={14} /> {t.label}
            </button>
          );
        })}
      </div>

      {tab === "branding" ? <Branding embedded /> : <Domains embedded />}
    </div>
  );
};

export default WhiteLabel;
